import React from 'react';
import { MessageCircle, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const CTAButton: React.FC = () => {
  const handleClick = () => {
    // Mensagem predefinida para o WhatsApp
    const message = "Olá, Dra. Lidiane!\nEncontrei seu contato pelo site e gostaria de solicitar algumas informações!";
    
    // Abrir WhatsApp com a mensagem
    window.open(`https://wa.me/5581993507689?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <>
      <motion.button 
        onClick={handleClick}
        className="bg-gradient-to-r from-accent to-accent/80 hover:from-accent/90 hover:to-accent/70 text-white font-semibold py-3.5 px-10 rounded-full transition-all duration-300 inline-flex items-center group shadow-lg shadow-accent/20"
        whileHover={{ scale: 1.05, boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)' }}
        whileTap={{ scale: 0.98 }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <motion.div
          className="flex items-center"
          initial={{ gap: '0.5rem' }}
          whileHover={{ gap: '0.75rem' }}
        >
          <motion.div 
            className="bg-white/20 p-1.5 rounded-full mr-3"
            animate={{ rotate: 360 }}
            transition={{ duration: 5, repeat: Infinity, ease: 'linear' }}
          >
            <MessageCircle size={16} />
          </motion.div>

          <span>Fale com um especialista</span>

          <motion.div
            animate={{ x: [0, 5, 0] }}
            transition={{ repeat: Infinity, duration: 1.5, repeatDelay: 1 }}
          >
            <ArrowRight size={16} className="ml-2" />
          </motion.div>
        </motion.div>
      </motion.button>
    </>
  );
};

export default CTAButton;